export const site = {
  'name': 'MatteuSan',
  'version': '3.5.1',
  'author': 'MatteuSan',
  'url': 'https://matteusan.com',
  'themeColor': '#eb5c00',
  'twitter': '@MatteuSan'
};
